// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

export interface LabReviewsRequestPayload {
  id: string;
  lab: number;
  helpful: number;
  comments: string;
  condition: string;
}

export interface LabReviewsFailPayload {
  error: Error;
}

export const postLabReviewsActions = createAsyncAction(
  'elearning/POST_LAB_REVIEWS_DATA',
  'elearning/POST_LAB_REVIEWS_DATA_SUCCESS',
  'elearning/POST_LAB_REVIEWS_DATA_FAIL'
)<LabReviewsRequestPayload, void, LabReviewsFailPayload>();
